"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBrandingCameraOffLDFlagEnabled = exports.isBrandingCameraOffFeatureEnabled = exports.dispatchBrandingSettings = void 0;
var _feature = require("@studio/feature.flags");
var _constants = require("@studio/constants");
var _logger = require("@studio/logger");
/**
 * checks whether camera off feature is enabled or not for Cventized events
 * @param {boolean} brandingSetting - Branding setting flag in a broadcast.
 * @returns {*|boolean}
 */
var isBrandingCameraOffFeatureEnabled = exports.isBrandingCameraOffFeatureEnabled = function isBrandingCameraOffFeatureEnabled(brandingSetting) {
  return isBrandingCameraOffLDFlagEnabled() && brandingSetting;
};

/**
 * checks whether branding camera off feature is enabled or not
 * @returns {*|boolean}
 */
var isBrandingCameraOffLDFlagEnabled = exports.isBrandingCameraOffLDFlagEnabled = function isBrandingCameraOffLDFlagEnabled() {
  return (0, _feature.shouldHaveFeature)('branding.cameraOffState');
};

/**
 * dispatches branding settings
 * @param {boolean} brandingSetting - Branding setting flag in a broadcast.
 * @param {function} dispatch - The Redux dispatch function used to send actions.
 * @param {function} getBrandingSettings - A function that returns an action to get branding settings.
 */
var dispatchBrandingSettings = exports.dispatchBrandingSettings = function dispatchBrandingSettings(brandingSetting, dispatch, getBrandingSettings) {
  if (brandingSetting) {
    dispatch(getBrandingSettings());
    var logPayload = {
      reduxActionFired: 'getBrandingSettings',
      title: "Fetching branding settings"
    };
    (0, _logger.sendToDatadog)('branding', logPayload, logPayload.title, false);
  } else {
    dispatch({
      type: "".concat(_constants.GET_BRANDING_SETTINGS, "_SUCCESS"),
      payload: _constants.DEFAULT_BRANDING
    });
  }
};